import React, { Component } from 'react'
import { isSet } from '../../utils/commonUtils'
import FormInputs from '../../components/UI/FormInputs';
import Skeleton from '../../components/SkeletonComponent/Skeleton';

export default class IncidentInjuryDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: "1",
            OrganList: []
        }
        this.fieldRefs = {}
    }
    componentDidUpdate(prevProps) {
        if (prevProps.validations !== this.props.validations && Object.keys(this.props.validations).length > 0) {
           this.props.handleErrorFocus(this.getInputFieldsTab1(), this.fieldRefs);
        }
    }
    setOrganList = (selectedOrganArray) => {
        this.setState({ OrganList: selectedOrganArray });
    }
    setOrganList1 = (selectedOrgan, selected) => {
        console.log('selectedOrgan, selected:', selectedOrgan, selected);
      
        // Parse existing selectedBodyPart - could be string or array
        let currentParts = [];
        if (this.props.selectedBodyPart) {
          if (typeof this.props.selectedBodyPart === 'string') {
            // Split comma-separated string into array, filter out empty strings
            currentParts = this.props.selectedBodyPart.split(',').map(part => part.trim()).filter(part => part !== '');
          } else if (Array.isArray(this.props.selectedBodyPart)) {
            currentParts = [...this.props.selectedBodyPart];
          }
        }
      
        let updatedParts = [];
        if (selected) {
          // Add organ if it doesn't already exist
          if (!currentParts.includes(selectedOrgan)) {
            updatedParts = [...currentParts, selectedOrgan];
          } else {
            updatedParts = [...currentParts];
          }
        } else {
          // Remove this organ if it exists
          updatedParts = currentParts.filter((part) => part !== selectedOrgan);
        }
      
        // Convert array to comma-separated string
        const updatedPartsString = updatedParts.join(',');
      
        // Update parent props with string
      
        // Send comma-separated string to onChangeHandler
        this.props.onChangeHandler("injury_locations", updatedPartsString);
        const organArray = updatedPartsString ? updatedPartsString.split(',') : [];
        this.props.setSelectedBodyPart(organArray);
        console.log("updatedPartsString", updatedPartsString);
      };
      
      
      
    // This method is called when the 'Body Zone' SelectList dropdown changes.
    handleDropdownChange = (value, e) => {
        console.log("Dropdown changed to:", value);
        // If the user selects "-", treat it as no selection (null)
        const finalValue1 = value === "" ? null : value;
        let finalValue =  value === "" ? null :  value
            .split(",")
            .filter(item => item !== "-" && item.trim() !== "")
            .join(",");
        this.props.onChangeHandler("injury_locations", finalValue, e);
        const organArray = finalValue ? finalValue.split(',') : [];
        this.props.setSelectedBodyPart(organArray);
      };

    getInjuryLocationValues = () => {
        const injuryLocations = isSet(this.props.formData["injury_locations"], '');
        if (!injuryLocations) return [];
        if (Array.isArray(injuryLocations)) return injuryLocations;
        if (typeof injuryLocations === 'string') {
            return injuryLocations.split(',').map((part) => part.trim()).filter((part) => part !== '');
        }
        return [];
    };

    renderFieldControl = (item, value, onChangeHandler, LookupList) => {
        const isBodyZoneDropdown = isSet(item.name, "") === "body_zone";
        const isInjuryLocationsDropdown = isSet(item.name, "") === "injury_locations";
        const isRadioGroup = isSet(item.name, "") === "relatedness" || isSet(item.name, "") === "incident_type";

        if (isRadioGroup) {
            return (
                <div className="d-flex flex-wrap gap-2 sh_incidentRadioGroup">
                    {item?.optionss.map((opt, ind) => (
                        <div className="form-check" key={ind}>
                            <FormInputs {...item} id={`${item.name}_${opt.label}`} value={value === opt.value} changeHandler={(val, e) => onChangeHandler(item.name, opt.value, e)} />
                            <label className="form-check-label" htmlFor={`${item.name}_${opt.label}`}>{opt.label}</label>
                        </div>
                    ))}
                </div>
            );
        }

        if (isBodyZoneDropdown) {
            return (
                <FormInputs
                    {...item}
                    value={value}
                    options={[
                        { label: "-Select-", value: "" },
                        ...(LookupList["body_zone"] || []),
                    ]}
                    changeHandler={(val, e) => onChangeHandler(item.name, val, e)}
                />
            );
        }

        if (isInjuryLocationsDropdown) {
            return (
                <FormInputs
                    {...item}
                    value={value}
                    options={this.state.OrganList}
                    changeHandler={this.handleDropdownChange}
                    enableScrollableDisplay={true}
                />
            );
        }

        return (
            <FormInputs
                {...item}
                value={value}
                changeHandler={(val, e) => onChangeHandler(item.name, val, e)}
            />
        );
    };

    renderFieldBlock = (item, itemIndex, formData, validations, onChangeHandler, LookupList) => {
        const value = isSet(formData[item.name], '');
        const colClass = item.col || 'col-12';

        return (
            <div className={`${colClass} sh_incidentFieldCol`} key={itemIndex}>
                <div className="form-group mb-2 sh_incidentField">
                    <label className="text-sm opacity-75 mb-1 d-block">{item.label}</label>
                    {this.renderFieldControl(item, value, onChangeHandler, LookupList)}
                    {isSet(validations[item.name], '') !== '' ? (
                        <span className="text-danger m-1 d-block">{isSet(validations[item.name], '')}</span>
                    ) : null}
                </div>
            </div>
        );
    };

    render() {
        const { validations, formData, onChangeHandler, LookupList } = this.props
        const inputFields = this.getInputFieldsTab1()
        const isLocationsSection = (title) =>
            isSet(title, "") === "Injury Locations" || isSet(title, "") === "Locations";

        return (
            <>
                {inputFields.map((section, secIndex) => (
                    <div className="card mb-2" key={secIndex}>
                        <a href={`#collapseCardExample_${secIndex}`} className="d-block sh_accordionheader card-header" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseCardExample" style={{ position: 'sticky', top: '-20px', zIndex: '1' }}>
                            <h6 className="mb-0 text-md">{section.title}</h6>
                        </a>
                        <div className="collapse show" id={`collapseCardExample_${secIndex}`} data-bs-parent="#modal111">
                            <div className="card-body">
                                {isLocationsSection(section.title) ? (
                                    <div className="sh_incidentLocationsWrap row g-3 mx-0 w-100">
                                        <div className="col-12 col-lg-6 d-flex justify-content-center sh_incidentSkeletonCol">
                                            <div className="sh_incidentSkeletonInner w-100">
                                                <Skeleton
                                                    onClick={this.setOrganList1}
                                                    editValue={this.getInjuryLocationValues()}
                                                    setOrganList={this.setOrganList}
                                                    selectedOrgans={this.state.OrganList}
                                                    width="350"
                                                    height="350"
                                                    isMultiSelect={true}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6">
                                            <div className="row g-2">
                                                {section.data.map((item, itemIndex) =>
                                                    this.renderFieldBlock(item, itemIndex, formData, validations, onChangeHandler, LookupList)
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="row g-2 sh_incidentDateTimeFields">
                                        {section.data.map((item, itemIndex) =>
                                            this.renderFieldBlock(item, itemIndex, formData, validations, onChangeHandler, LookupList)
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </>
        )
    }
 
    getInputFieldsTab1 = () => {
        const { isSimplifiedCategory } = this.props;
        const fieldCol = 'col-12 col-md-6';
        const fieldColFull = 'col-12';
        
        // Base fields for Incident / Injury Date & Times
        const dateTimeFields = [
            { type: "Date", label: "Date of Incident", placeholder: "Set Date", className: "form-control form-control-solid",required:true, name: "date_of_incident", col: fieldCol },
        ];
        
        // Add time and date reported fields only for non-simplified categories
        if (!isSimplifiedCategory) {
            dateTimeFields.push(
                { type: "Time", label: "Time of Incident", placeholder: "Set Time", className: "sh_incidenttime-input", name: "time_of_incident", col: fieldCol },
                { type: "Date", label: "Date Reported", col: fieldCol, placeholder: "Date Reported", className: "form-control form-control-solid",required:true, name: "date_reported" },
                { type: "Time", label: "Time Reported", placeholder: "Set Time", className: "sh_incidenttime-input", name: "time_reported", col: fieldCol }
            );
        }
        
        // Add description field with different label based on category
        const descriptionLabel = isSimplifiedCategory ? "Describe illness or injury details" : "Patient Incident Description";
        dateTimeFields.push(
            { type: "TextArea", label: descriptionLabel, placeholder: "", className: "form-control form-control-solid",required:true, name: "patient_incident_description", col: fieldColFull }
        );
        
        // Locations section title and label
        const locationsTitle = isSimplifiedCategory ? "Locations" : "Injury Locations";
        const locationsLabel = isSimplifiedCategory ? "Locations" : "Injury Locations";
        
        const sections = [
            {
                title: 'Incident / Injury Date & Times',
                data: dateTimeFields
            },
            {
                title: locationsTitle,
                data: [
                     {
                        type: "SelectList",
                        label: "Nature of Incident",
                        col: fieldColFull,
                        placeholder: "Nature of Incident",
                        className: "form-control form-control-solid",
                        required:true,
                        name: "nature_of_incident",
                        options: [
                                 { label: "-Select-", value: "" }, 
                                 ...(this.props.LookupList["nature_of_incident"] || [])
                                ],
                    },
                    {
                        type: "SelectList",
                        label: "Body Zone",
                        placeholder: "Body Zone",
                        className: "form-control form-control-solid",
                        required:true,
                        options: this.props.LookupList["body_zone"],
                        name: "body_zone",
                        col: fieldColFull,
                    },
                    {
                        type: "SelectSearchList",
                        label: locationsLabel,
                        placeholder: locationsLabel,
                        className: "form-control form-control-solid",
                        required:true,
                        isMulti: true,
                        closeOnMultiSelect: false,
                        name: "injury_locations",
                        col: fieldColFull,
                    },
                   
                ]
            }
        ];
        
        // Add Incident / Injury Details section only for non-simplified categories
        if (!isSimplifiedCategory) {
            sections.push({
                title: 'Incident / Injury Details',
                data: [
                    { type: "TextInput", label: "Claim Number", placeholder: "Claim Number", className: "form-control form-control-solid", name: "claim_number", col: fieldCol,  },
                    {
                        type: "Radio", isLabelAppend: true, label: "Relatedness", placeholder: "", className: "form-check-input", name: "relatedness", col: fieldColFull,
                        optionss: [{ label: "Work Related", value: "Work Related" }, { label: "First Aid", value: "First Aid" }, { label: "Undetermined", value: "Undetermined" }]
                    },
                    {
                        type: "Radio", isLabelAppend: true, label: "Incident Type", col: fieldColFull, placeholder: "", className: "form-check-input", name: "incident_type",
                        optionss: [{ label: "Injury", value: "Injury" }, { label: "Exposure", value: "Exposure" }, { label: "Illness", value: "Illness" }]
                    },
                    { type: "Date", label: "Declined Date", col: fieldCol, placeholder: "Declined Date", className: "form-control form-control-solid", name: "declined_date" },
                    { type: "Date", label: "Discharge Date", col: fieldCol, placeholder: "Discharge Date", className: "form-control form-control-solid", name: "discharge_date" },
                    { type: "TextInput", label: "Snap Case Number", placeholder: "Snap Case Number", className: "form-control form-control-solid", name: "snap_case_number", col: fieldCol, readOnly: true },
                ]
            });
        }
        
        return sections;
    }
}
